export const passwordRegex = /^.{8,30}$/;
export const usernameRegex = /^[a-zA-Z0-9_]{5,24}$/;
